import React, { useState, useContext } from "react";
import { injectIntl } from "gatsby-plugin-intl";
import { Segment, Visibility } from "semantic-ui-react";
import { ThemeContext } from "../store/theme";
import HomepageHeading from "./HomepageHeading";
import NavBar from "./NavBar";
import LandingBanner from "./LandingBanner";
import BetaBanner from "./BetaBanner";

const DesktopContainer = ({ intl, help, landing, children, offer, buy }) => {
  const [fixed, setFixed] = useState(false);
  const { state } = useContext(ThemeContext);
  const { darkmode } = state;

  const transition = landing;

  return (
    <div>
      {landing ? (
        <Visibility
          once={false}
          onBottomPassed={() => setFixed(true)}
          onBottomPassedReverse={() => setFixed(false)}
        >
          {intl.locale === "ko" && <BetaBanner />}
          {offer && <LandingBanner landing showButton />}
          <Segment
            inverted
            textAlign="center"
            style={{
              minHeight: 700,
              padding: "1em 0em",
              backgroundColor: darkmode ? "#262626" : "#015A9E",
              transition: transition
                ? "color 1s ease-out, background-color 1s ease-out"
                : "none",
            }}
            vertical
          >
            <NavBar landing help={help} fixed={fixed} />
            <HomepageHeading />
          </Segment>
        </Visibility>
      ) : (
        <Segment
          style={{
            paddingTop: 35,
          }}
          vertical
        >
          <NavBar fixed />
        </Segment>
      )}
      {children}
    </div>
  );
};

export default injectIntl(DesktopContainer);
